import { ADMIN_SAVE_COMPANY_USER } from "$mutations";
import { GET_COMPANY_USERS_BY_COMPANY } from "$queries";
import { IMutationOptions, useMutation } from "$hooks";
import { IPaginatedResult } from "$hooks/queries/interfaces";
import { ICompanyUser } from "$interfaces/CompanyUser";
import { ICompanyUserInput } from "$interfaces/User";

export const useAdminSaveCompanyUser = () => {
  const { mutation, ...result } = useMutation<IAdminSaveCompanyUserInput, IResponseProps>(
    ADMIN_SAVE_COMPANY_USER
  );

  const adminSaveCompanyUser = ({
    variables,
    ...options
  }: IMutationOptions<IResponseProps, IAdminSaveCompanyUserInput>) =>
    mutation({
      variables,
      ...options,
      update: (cache, { data }) => {
        cache.modify({
          fields: {
            getCompanyUsersByCompany: async (
              existingCompanyUsers: IPaginatedResult<ICompanyUser>
            ) => {
              await cache.writeQuery({
                data: {
                  getCompanyUsersByCompany: {
                    results: [data?.adminSaveCompanyUser],
                    shouldFetchMore: true
                  }
                },
                query: GET_COMPANY_USERS_BY_COMPANY
              });
              return existingCompanyUsers;
            }
          }
        });
      }
    });

  return { adminSaveCompanyUser, ...result };
};

interface IResponseProps {
  adminSaveCompanyUser: ICompanyUser;
}

export interface IAdminSaveCompanyUserInput {
  user: ICompanyUserInput;
  companyUuid: string;
}
